<template>
  <span>
    <Select
      v-model="data[0]"
      style="margin-right: 20px"
      :placeholder="placeholder"
      @change="handleBaseSelectChange"
    >
      <Option
        v-for="item in baseList"
        :key="item.key"
        :label="item.name"
        :value="item.key"
        :disabled="item.key === data[1] && showContrast"
      />
    </Select>

    <Checkbox
      v-model="showContrast"
      style="margin-right: 20px"
      @change="handleCheckboxChange"
    >
      {{ contrastText }}
    </Checkbox>

    <Select
      v-if="showContrast"
      v-model="data[1]"
      :placeholder="placeholder"
      @change="handleContrastSelectChange"
    >
      <Option
        v-for="item in contrastList"
        :key="item.key"
        :label="item.name"
        :value="item.key"
        :disabled="item.key === data[0]"
      />
    </Select>
  </span>
</template>

<script>
import { Select, Option, Checkbox } from 'element-ui';

export default {
  components: {
    Select,
    Option,
    Checkbox,
  },

  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },

    placeholder: {
      type: String,
      default: '请选择',
    },

    baseList: {
      type: Array,
      default() {
        return [];
      },
    },

    contrastList: {
      type: Array,
      default() {
        return [];
      },
    },

    isContrast: {
      type: Boolean,
      default: false,
    },

    defaultContrast: {
      type: String,
      default: '',
    },

    contrastText: {
      type: String,
      default: '指标对比',
    },
  },

  data() {
    return {
      data: this.value,
      // 是否展示对比数据
      showContrast: this.isContrast,
    };
  },

  watch: {
    isContrast(newVal) {
      this.showContrast = newVal;
    },
  },

  methods: {
    handleBaseSelectChange() {
      this.$emit('change', this.data);
    },

    handleContrastSelectChange() {
      this.$emit('change', this.data);
    },

    handleCheckboxChange() {
      if (this.showContrast) {
        if (this.data[0] !== this.defaultContrast) {
          this.data[1] = this.defaultContrast;
        } else {
          const current = this.contrastList.filter(
            (item) => item.key !== this.defaultContrast,
          );
          this.data[1] = current[0].key;
        }
        this.$emit('update:isContrast', true);
      } else {
        this.data[1] = '';
        this.$emit('update:isContrast', false);
      }
      this.$emit('change', this.data);
    },
  },
};
</script>
